import { NgModule } from '@angular/core';
import { ThemeModule } from '../@theme/theme.module';
import { AuthRoutingModule, routedComponents } from './auth-routing.module';
import { NbSpinnerModule, NbButtonModule } from '@nebular/theme';
import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    ThemeModule,
    NbSpinnerModule,
    NbButtonModule,
    AuthRoutingModule,
  ],
  declarations: [
    ...routedComponents,
  ],
  providers: [
    NgbActiveModal,
  ],
})
export class AuthModule { }
